import { render, staticRenderFns } from "./PdfViewer.vue?vue&type=template&id=5946e712"
import script from "./PdfViewer.vue?vue&type=script&lang=js"
export * from "./PdfViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5946e712')) {
      api.createRecord('5946e712', component.options)
    } else {
      api.reload('5946e712', component.options)
    }
    module.hot.accept("./PdfViewer.vue?vue&type=template&id=5946e712", function () {
      api.rerender('5946e712', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/player/components/PdfViewer.vue"
export default component.exports